module.exports = __webpack_public_path__ + "img/icono-movil.05a2ffcd.png";